import React from 'react'

export default function ({
  label,
  value,
  onChange,
  onEnter = () => {},
  type = 'text',
  labelColor = '#14B0BF',
  marginTop = 20,
  disabled = false,
  showLabel = true,
  placeholder = '',
  autoComplete = undefined,
  name = 'myInput',
  inputStyle = {},
  maxLength = undefined,
  inputMode = undefined,
  autoFocus = false,
}) {
  const styles = {
    container: {
      textAlign: 'left',
      marginTop,
    },
    label: {
      fontSize: '0.8rem',
      color: labelColor,
    },
    input: {
      width: '100%',
      outline: 'none',
      border: '1px solid #F1F1F1',
      borderRadius: 3,
      height: 30,
      marginTop: 3,
      padding: 10,
    },
  }
  return (
    <div style={styles.container}>
      {showLabel ? (
        <label style={styles.label} htmlFor={name}>
          {label}
        </label>
      ) : null}
      <input
        disabled={disabled}
        style={{ ...styles.input, ...inputStyle }}
        type={type}
        name={name}
        autoComplete={autoComplete}
        maxLength={maxLength}
        inputMode={inputMode}
        autoFocus={autoFocus}
        value={value}
        placeholder={placeholder}
        onChange={evt => onChange(evt.target.value)}
        onKeyPress={({ key }) => {
          if (key === 'Enter') {
            onEnter()
          }
        }}
      />
    </div>
  )
}
